import { TableCell, TableRow } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";

const DecrementRow = ({ row }) => {
  return (
    <TableRow key={row.symbol} >
      <TableCell sx={{ textAlign: "center" }}>{row.commodity_type}</TableCell>
      <TableCell sx={{ textAlign: "center" }}>{row.transit}</TableCell>
      <TableCell sx={{ textAlign: "center", color: COLORS.RED }}>
        {row.deviation}%
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>{row.last_price_date}</TableCell>
    </TableRow>
  );
};

export default DecrementRow;
